import TradeHistoryModel from '@trading/core/src/models/tradeHistory.model'
import type { TradeHistoryRepository, GetAllTradeHistoryDTO } from '@trading/core'
import axios from '../axios'
import type { ApiResponse } from '../types'

export class TradeHistoryApiAxios implements TradeHistoryRepository {
  async getAll(dto: GetAllTradeHistoryDTO) {
    return await axios
      .get<ApiResponse<TradeHistoryModel>>(`account/trades`, {
        params: dto
      })
      .then((resp) => {
        if (!resp.data.success) {
          throw new Error(resp.data.error?.toString())
        }

        const { trades, summary } = resp.data.data
        return new TradeHistoryModel(trades, summary, resp.data.pagination?.next_cursor ?? null)
      })
      .catch((e) => {
        throw new Error(e)
      })
  }
}
